import { all } from 'redux-saga/effects';

import { watchDriverSalaryAdjustments } from './driverSalaryAdjustments/sagas/watcher';
import { watchNomenclature } from './nomenclature/sagas/watcher';
import { watchNomenclatureCustomName } from './nomenclatureCustomName/sagas/watcher';
import { watchReport } from './report/sagas/watcher';
import { watchShift } from './shift/sagas/watcher';

export default function* rootSaga(): Generator {
  try {
    yield all([
      watchNomenclature(),
      watchShift(),
      watchReport(),
      watchDriverSalaryAdjustments(),
      watchNomenclatureCustomName(),
    ]);
  } catch (error) {
    //console.log('_____error root saga____-', error);
  }
}
